import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './style.css'
import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/auth'

const app = createApp(App)

app.use(createPinia())
app.use(router)

const authStore = useAuthStore()
// authStore.initAuth() // handled in router

// Global Error Handler
app.config.errorHandler = (err, instance, info) => {
    console.error("Global Vue Error:", err)
    console.error("Info:", info)
    // alert(`Error: ${err.message || err}`) // Optional: Alert for immediate visibility
}

window.addEventListener('unhandledrejection', event => {
    console.error("Unhandled Promise Rejection:", event.reason)
    // alert(`Unhandled Promise Rejection: ${event.reason}`)
});

app.mount('#app')
